import { render, staticRenderFns } from "./NoticeComponent.vue?vue&type=template&id=1ab049b0&scoped=true"
import script from "./NoticeComponent.vue?vue&type=script&lang=js"
export * from "./NoticeComponent.vue?vue&type=script&lang=js"
import style0 from "./NoticeComponent.vue?vue&type=style&index=0&id=1ab049b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab049b0",
  null
  
)

export default component.exports